import SettingsLayout from "./layout/SettingsLayout";
import { useSearchParams } from "react-router-dom";
import {useEffect, useState} from "react";
import {
  confirmCouponCode,
  getVolatilityMessage,
  saveNotification, validContent,
} from "../api/message/volatility-message.api";
import SettingsStepLayout from "./layout/SettingsStepLayout";
import MessageDefaultInfo from "./volatility-message/MessageDefaultInfo";
import MessageContentsSettings from "./volatility-message/content/setting/MessageContentsSettings";
import MessageTargetSetting from "./volatility-message/MessageTargetSetting";
import MessageConfirm from "./volatility-message/content/MessageConfirm";
import moment from "moment";
import SuspensePopup from "./SuspensePopup";
import {getMessagePrice} from "../libs/helper";
import CheckCreditModalForm from "./form/CheckCreditModalForm";

const VolatilityMessageSettings = () => {
  const [query] = useSearchParams();
  const tabs = ["기본 설정", "콘텐츠 작성하기", "대상 및 발송일정", "최종 확인"]
  const [tab, setTab] = useState(1);
  const [message, setMessage] = useState({
    campaignName: "1회성 메시지 캠페인",
    type: "FI", messageData: { type: "FI" },
    issuedAt: {
      date: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD")
      },
      hour: String(moment().hours()).padStart(2, "0"),
      min: String(moment().minutes()).padStart(2, "0")
    }
  })
  const [isConfirm, setIsConfirm] = useState(false)
  const [disabledTempBtn, setDisabledTempBtn] = useState(false)
  const [customerCnt, setCustomerCnt] = useState(0)
  const [countAllFriend, setCountAllFriend] = useState(0)
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false)
  const [deductMoney, setDeductMoney] = useState(0)
  const [showMoneyModal, setShowMoneyModal] = useState(false)
  const [validCredit, setValidCredit] = useState(true)

  const id = query.get("id");

  useEffect(() => {
    if (id) {
      getVolatilityMessage(id).then(({data}) => {
        if (!data) {
          alert("데이터를 불러올 수 없습니다.")
          window.location.href = "/volatility-message"
        }
        const reserved = moment(data.issuedAt, "YYYY-MM-DD HH:mm")
        data.issuedAt = {
          date: {
            startDate: reserved.format("YYYY-MM-DD"),
            endDate: reserved.format("YYYY-MM-DD")
          },
          hour: String(reserved.hours()).padStart(2, "0"),
          min: String(reserved.minutes()).padStart(2, "0")
        }
        setMessage(data)
      })
    }
  }, [id]);

  useEffect(() => {
    setDeductMoney(
        getMessagePrice(message.type) * customerCnt
        + (countAllFriend > 0 && 22 * countAllFriend)
    )
    setNextButtonDisabled(customerCnt === 0 && countAllFriend <= 10)
  }, [customerCnt, countAllFriend, message.targetType]);

  const handleConfirm = async (status) => {
    setIsConfirm(false)
    setDisabledTempBtn(false)

    // 발송(예약) 등록 전에 쿠폰 코드 잔량을 먼저 확인한다.
    // 임시저장은 발송이 아니므로 건너뛴다(작성 중에 경고가 뜨면 방해만 된다).
    //
    // 대상 수로 `customerCnt` 를 쓴다 — 쿠폰은 회원에게만 발급되므로(혜택 발급에 회원 id 가
    // 필요하다) 비회원 친구 발송분(`countAllFriend`)은 코드를 쓰지 않는다.
    if (status === "RESERVED" && !(await confirmCouponCode(message.messageData, customerCnt))) {
      return
    }

    saveNotification(status, message, "ONETIME").then(() => {
      alert(
          status === "RESERVED" ? "발송이 등록되었습니다." : "임시 저장되었습니다."
      );
      window.location.replace("/volatility-message");
    })
  };

  const updateMessage = (key, value) => {
    const newMessage = { ...message }
    newMessage[key] = value
    setMessage(newMessage)
  }

  const updateMessageData = (key, value) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}
    messageData[key] = value
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const updateMessageDataArrays = (arrayKeys, value) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}

    let currentLevel = messageData;
    arrayKeys.forEach((arrayKey, idx) => {
      const isIndex = !isNaN(Number(arrayKeys[idx + 1]))
      currentLevel[arrayKey] = currentLevel[arrayKey] ?? (isIndex ? [] : {})

      if (idx < arrayKeys.length - 1) {
        currentLevel = currentLevel[arrayKey]
      } else {
        currentLevel[arrayKey] = value
      }
    })
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const deleteMessageDataArrays = (index, arrayKeys) => {
    const newMessage = { ...message }
    const messageData = newMessage.messageData ?? {}
    messageData[arrayKeys] = messageData[arrayKeys] ?? []
    messageData[arrayKeys] = messageData[arrayKeys].filter((_, i) => i !== index)
    newMessage.messageData = messageData
    setMessage(newMessage)
  }

  const description = () => {
    if (tab === 0) {
      return "메시지의 기본 정보를 설정해 주세요."
    } else {
      return ""
    }
  }

  useEffect(() => {
    if (tab === 1) {
      setNextButtonDisabled(false)
    }if (tab === 2) {
      setNextButtonDisabled(!validContent(message.messageData))
    }
  }, [tab, message]);

  const render = () => {
    const messageData = message.messageData ?? {}
    const type = messageData.type
    const filters = message.filters ?? {}
    const issuedAt = message.issuedAt

    if (tab === 1) {
      return (
          <MessageDefaultInfo id={id}
                              campaignName={message?.campaignName}
                              type={type}
                              onChangeCampaignName={(campaignName) => {
                                updateMessage("campaignName", campaignName)
                              }}
                              onChangeMessageType={(type) => {
                                updateMessageData("type", type)
                              }}
          />
      )
    } else if (tab === 2) {
      return (
          <MessageContentsSettings isConnect={true}
                                   type={type}
                                   messageData={messageData}
                                   onChangeMessageData={(key, value) => updateMessageData(key, value)}
                                   onChangeImage={(key, imgUrl) => {
                                     const newMessage = { ...message }
                                     const messageData = newMessage.messageData ?? {}
                                     messageData["type"] = imgUrl === undefined ? "FT" : "FI"
                                     if (!messageData.image) {
                                       messageData["image"] = {}
                                     }
                                     messageData["image"][key] = imgUrl
                                     newMessage.messageData = messageData
                                     setMessage(newMessage)
                                   }}
                                   onChangeMessageDataArrays={(arrayKeys, value) => updateMessageDataArrays(arrayKeys, value)}
                                   onDeleteMessageDataArrays={(index, arrayKeys) => deleteMessageDataArrays(index, arrayKeys)}
          />
      )
    } else if (tab === 3) {
      return (
          <MessageTargetSetting
              id={id}
              selectedTargetFilters={filters}
              reservedDate={issuedAt}
              isSendMoment={message.isSendMoment}
              useBrandMsg={message.useBrandMsg}
              onChangeSendMoment={(flag) => {
                updateMessage("isSendMoment", flag)
              }}
              onChangeTargetType={(type) => {
                updateMessage("targetType", type)
              }}
              onChangeTargetFilters={(filters) => {
                updateMessage("filters", filters)
              }}
              onChangeCustomerCnt={(count) => {
                setCustomerCnt(count)
              }}
              type={type}
              messageData={messageData}
              onChangeReservedDate={(issuedAt) => {
                updateMessage("issuedAt", issuedAt)
              }}
              onChangeAdult={(flag) => {
                updateMessageData("adult", flag)
              }}
              selectUserIds={message.selectUserIds}
              onChangeSelectUserIds={(userIds) => {
                updateMessage("selectUserIds", userIds)
              }}
              countAllFriend={countAllFriend}
              onChangeSendFriend={(count) => {
                setCountAllFriend(count)
                updateMessage("sendAllFriend", count > 10)
              }}
              onUseBrandMsg={(checked) => {
                updateMessage("useBrandMsg", checked)
              }}
          />
      )
    } else if (tab === 4) {
      return (
          <MessageConfirm
              message={message}
              deductMoney={deductMoney}
              customerCount={customerCnt + countAllFriend}
              isSendMoment={countAllFriend === 0}
              onValidState={setIsConfirm}
          />
      )
    }
  };

  return (
    <SettingsLayout
      title={"메시지 보내기"}
      tabs={tabs}
      activeTab={tab}
      isTemporarySave={!disabledTempBtn}
      onTemporarySave={() => handleConfirm("TEMPORARY")}
      onConfirm={() => handleConfirm("RESERVED")}
      onChange={setTab}
      isConfirm={isConfirm}
      nextButtonDisabled={nextButtonDisabled}
      confirmText={"등록하기"}
      onClose={() => window.location.href = ("/volatility-message")}
      backLocation={"/volatility-message"}
    >
      <SettingsStepLayout description={description()} renderChild={render()} />
      {/*
        <SuspensePopup visible={showMoneyModal} title="예치금 차감 안내" onConfirm={() => {
          if (validCredit) {
            handleConfirm("RESERVED")
          }
        }} onClose={() => setShowMoneyModal(false)}>
          <CheckCreditModalForm deductMoney={deductMoney} onValid={setValidCredit} />
        </SuspensePopup>
      */}
    </SettingsLayout>
  );
};
export default VolatilityMessageSettings;
